export const treeItems = [
  {
    Id: 12,
    ParentId: 10,
    Description: "Κατάσταση Αιτήσεων",
    ViewDefinition: {
      showZeros: false,
      showColumnTotals: 1,
      showRowTotals: 1,
      defaultFilterType: 3,
      totalsBeforeData: false,
      sortableGroups: true,
      fields: [
        {
          binding: "Id",
          header: "Αριθμός Αιτήσεων",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "Αριθμός Αιτήσεων",
        },
        {
          binding: "StatusCellCss",
          header: "undefined1",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "undefined1",
        },
        {
          binding: "ProtocolNumber",
          header: "Α/Α",
          dataType: 2,
          aggregate: 1,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "Α/Α",
        },
        {
          binding: "Type",
          header: "ΤΥΠΟΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΤΥΠΟΣ",
        },
        {
          binding: "Status",
          header: "ΚΑΤΑΣΤΑΣΗ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΚΑΤΑΣΤΑΣΗ",
        },
        {
          binding: "CustomDate",
          header: "ΗΜΕΡΟΜΗΝΙΑ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΗΜΕΡΟΜΗΝΙΑ",
        },
        {
          binding: "NumAptms",
          header: "ΔΙΑΜ.",
          dataType: 2,
          aggregate: 1,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΔΙΑΜ.",
        },
        {
          binding: "SumCapacity",
          header: "ΔΥΝΑΜ.",
          dataType: 2,
          aggregate: 1,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΔΥΝΑΜ.",
        },
        {
          binding: "NumEmpl",
          header: "ΑΡ.ΥΠΑΛ/ΩΝ",
          dataType: 2,
          aggregate: 1,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΑΡ.ΥΠΑΛ/ΩΝ",
        },
        {
          binding: "Budget",
          header: "Π/Υ",
          dataType: 2,
          aggregate: 1,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "Π/Υ",
        },
        {
          binding: "HQName",
          header: "ΕΠΩΝΥΜΙΑ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΕΠΩΝΥΜΙΑ",
        },
        {
          binding: "HQAbbr",
          header: "ΔΙΑΚΡΙΤΙΚΟΣ ΤΙΤΛΟΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΔΙΑΚΡΙΤΙΚΟΣ ΤΙΤΛΟΣ",
        },
        {
          binding: "HQAFM",
          header: "ΑΦΜ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΑΦΜ",
        },
        {
          binding: "HQInstituteType",
          header: "ΤΥΠΟΣ ΦΟΡΕΑ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΤΥΠΟΣ ΦΟΡΕΑ",
        },
        {
          binding: "HQInstituteCategory",
          header: "ΝΟΜΙΚΗ ΜΟΡΦΗ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΝΟΜΙΚΗ ΜΟΡΦΗ",
        },
        {
          binding: "BranchName",
          header: "ΕΠΩΝΥΜΙΑ15",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΕΠΩΝΥΜΙΑ15",
        },
        {
          binding: "BranchAbbr",
          header: "ΔΙΑΚΡΙΤΙΚΟΣ ΤΙΤΛΟΣ16",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΔΙΑΚΡΙΤΙΚΟΣ ΤΙΤΛΟΣ16",
        },
        {
          binding: "BranchAFM",
          header: "ΑΦΜ17",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΑΦΜ17",
        },
        {
          binding: "BranchInstituteType",
          header: "ΤΥΠΟΣ ΦΟΡΕΑ18",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΤΥΠΟΣ ΦΟΡΕΑ18",
        },
        {
          binding: "BranchInstituteCategory",
          header: "ΝΟΜΙΚΗ ΜΟΡΦΗ19",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΝΟΜΙΚΗ ΜΟΡΦΗ19",
        },
        {
          binding: "LegalRepresentativeFullName",
          header: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
        },
        {
          binding: "LegalRepresentativePhone",
          header: "ΤΗΛΕΦΩΝΟ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΤΗΛΕΦΩΝΟ",
        },
        {
          binding: "LegalRepresentativeEmail",
          header: "Email",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "Email",
        },
        {
          binding: "ScientificDirectorFullName",
          header: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ23",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ23",
        },
        {
          binding: "ScientificDirectorPhone",
          header: "ΤΗΛΕΦΩΝΟ24",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΤΗΛΕΦΩΝΟ24",
        },
        {
          binding: "ScientificDirectorEmail",
          header: "Email25",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "Email25",
        },
        {
          binding: "ScientificDirectorAMKA",
          header: "ΑΜΚΑ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΑΜΚΑ",
        },
        {
          binding: "ScientificDirectorAFM",
          header: "ΑΦΜ27",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΑΦΜ27",
        },
        {
          binding: "ScientificDirectorJobTitle",
          header: "ΙΔΙΟΤΗΤΑ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΙΔΙΟΤΗΤΑ",
        },
        {
          binding: "CreatedAt",
          header: "ΗΜ/ΝΙΑ ΔΗΜΙΟΥΡΓΙΑΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΗΜ/ΝΙΑ ΔΗΜΙΟΥΡΓΙΑΣ",
        },
        {
          binding: "CreatedBy",
          header: "ΧΡΗΣΤΗΣ ΔΗΜΙΟΥΡΓΙΑΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΧΡΗΣΤΗΣ ΔΗΜΙΟΥΡΓΙΑΣ",
        },
        {
          binding: "UpdatedAt",
          header: "ΗΜ/ΝΙΑ ΕΝΗΜΕΡΩΣΗΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΗΜ/ΝΙΑ ΕΝΗΜΕΡΩΣΗΣ",
        },
        {
          binding: "UpdatedBy",
          header: "ΧΡΗΣΤΗΣ ΕΝΗΜΕΡΩΣΗΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΧΡΗΣΤΗΣ ΕΝΗΜΕΡΩΣΗΣ",
        },
        {
          binding: "SubmittedAt",
          header: "ΗΜ/ΝΙΑ ΥΠΟΒΟΛΗΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΗΜ/ΝΙΑ ΥΠΟΒΟΛΗΣ",
        },
        {
          binding: "SubmittedBy",
          header: "ΧΡΗΣΤΗΣ ΥΠΟΒΟΛΗΣ",
          dataType: 1,
          aggregate: 2,
          showAs: 0,
          descending: false,
          format: "n0",
          isContentHtml: false,
          key: "ΧΡΗΣΤΗΣ ΥΠΟΒΟΛΗΣ",
        },
      ],
      rowFields: { items: ["ΚΑΤΑΣΤΑΣΗ"] },
      columnFields: { items: [] },
      filterFields: { items: [] },
      valueFields: { items: ["Αριθμός Αιτήσεων"] },
    },
    isFolder: false,
  },
  {
    Id: 13,
    ParentId: 10,
    Description: "Κατάσταση Αιτήσεων 2",
    ViewDefinition: "",
  },
];
